<template>
  <transition-group name="list" tag="div" class="flex flex-wrap -mx-10">
    <div v-for="routine in routines" :key="routine.id" class="md:w-1/2 xl:w-1/3 w-full px-10 pb-10">
      <RoutinePreview :routine="routine" :tag-facets="tagFacets" />
    </div>
  </transition-group>
</template>

<script>
import RoutinePreview from '@/components/exercises/RoutinePreview';

export default defineNuxtComponent({
  components: {
    RoutinePreview,
  },
  props: {
    routines: {
      type: Array,
      required: true,
    },
    tagFacets: {
      type: Array,
      default: () => [],
    },
  },
});
</script>

<style>
@reference "~/assets/css/main.css";
.list-enter-active,
.list-leave-active {
  @apply transition-all delay-500;
}
.list-enter,
.list-leave-to {
  @apply opacity-0;
}
</style>
